import script from "./Purchase.vue?vue&type=script&setup=true&lang=js"
export * from "./Purchase.vue?vue&type=script&setup=true&lang=js"

import "./Purchase.vue?vue&type=style&index=0&id=27daae70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27daae70"]])

export default __exports__